import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase } from '../../domain/entities';

export class SendFanDocumentUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, method: 'email' | 'link'): Promise<TncCase> {
    return this.tncRepository.sendFanDocument(caseId, method);
  }
}
